export class DateUtils {
    static formatDate(date: Date): string {
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear().toString();
      let hours = date.getHours();
      const minutes = date.getMinutes().toString();
      let ampm: string;
      if (hours >= 12) {
        ampm = 'PM';
        hours -= 12;
      } else {
        ampm = 'AM';
      }
      return `${day}/${month}/${year} - ${hours}:${minutes} ${ampm}`;
    }
  }